import React, {useRef} from "react";
import {RoundedCustomButton} from "./CustomIcon";

const SCROLL_OFFSET = 20;
const SCROLL_TIME_MARGIN = 1000;

const ScrollLayout = ({
                        className, isVertical = false, onScroll,
                        children, scrollDistance = 0, classNav = "mx-8",
                        loading = false,
                        showNav = false,
                        isNavOverlay= false
                      }) => {

  let scrollPrevented = false;
  const scrollRef = useRef(null);
  const handleScroll = (e) => {
    if (onScroll && !isVertical && !loading && e.target.offsetWidth + e.target.scrollLeft + SCROLL_OFFSET >= e.target.scrollWidth) {
      if (!scrollPrevented) {
        scrollPrevented = true;
        onScroll();
        setTimeout(() => scrollPrevented, SCROLL_TIME_MARGIN);
      }
    }

    if (onScroll && isVertical && e.target.offsetHeight + e.target.scrollTop + SCROLL_OFFSET >= e.target.scrollHeight) {
      if (!scrollPrevented) {
        scrollPrevented = true;
        onScroll();
        setTimeout(() => scrollPrevented = false, SCROLL_TIME_MARGIN);
      }
    }
  };

  const scrollManually = (offset) => {


    if (scrollRef.current.scrollLeft !== undefined)

      // scrollRef.current.scrollLeft = scrollRef.current.offsetWidth + scrollRef.current.scrollLeft;
      scrollRef.current.scrollTo({
        top: 0,
        left: Math.min((offset * scrollRef.current.offsetWidth) + scrollDistance + scrollRef.current.scrollLeft, scrollRef.current.scrollWidth),
        behavior: 'smooth'
      });

  };

  return (
    isVertical ?
      <div className={`vertical${className ? ` ${className}` : ''}`}
           onScroll={handleScroll}>
        {children}
      </div> :
      <div className="flex items-center w-full">
        {showNav && <RoundedCustomButton size="2xl" className={`left-arrow ${isNavOverlay ? `shadow-md shrink-0 absolute z-regular mx-0 -left-3.5` : ""}${classNav ? ` ${classNav}` : ''}`} icon="chevron_left"
                                         onClick={() => scrollManually(-1)}/>}
        <div className={`flex-grow horizontal${className ? ` ${className}` : ''}`} ref={scrollRef}
             onScroll={handleScroll}>
          {children}
        </div>
        {showNav && <RoundedCustomButton size="2xl" className={`right-arrow ${isNavOverlay ? `shadow-md shrink-0 absolute z-regular mx-0 -right-3.5` : ""}${classNav ? ` ${classNav}` : ''}`} icon="chevron_right" isLeft={false}
                                         onClick={() => scrollManually(1)}/>}
      </div>
  );


};

export default ScrollLayout;
